export default class LackingYieldReason {
  reason: string;
  lackingYieldSum: number;
  displayName: string;
  underlyingStatusTypes: string[];

  constructor(
    reason: string,
    lackingYieldSum: number,
    displayName: string,
    underlyingStatusTypes: string[],
  ) {
    this.reason = reason;
    this.lackingYieldSum = lackingYieldSum;
    this.displayName = displayName;
    this.underlyingStatusTypes = underlyingStatusTypes;
  }
}
